export enum ShortCodeType {
    Microsite = 1,
    Campaign = 2
}